/** Мок API: счета. */
import type { FakeDb, FakeHandlers } from "./db";

export function paymentsHandlers(_db: FakeDb): FakeHandlers<"createInvoice" | "starterSeen"> {
  return {
    createInvoice: async () => ({ url: "https://t.me/$fake-invoice" }),
    starterSeen: async () => ({}),
  };
}
